import httpClient from "../http/http-client";
import { IIntensityRatio, IIntensityRatioUpdate } from './intensity-ratio.model';

export default class IntensityRatioService {
  http;

  constructor() {
    this.http = httpClient
  }

  /** The org's merged intensity-ratio catalog (definitions + enable/order state). */
  async getAll(): Promise<IIntensityRatio[]> {
    return this.http.get(`intensity-ratio-setting`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  /** Only the enabled ratios, in display order. Used by consumers (SECR form etc.). */
  async getEnabled(): Promise<IIntensityRatio[]> {
    return this.getAll().then(ratios => ratios.filter(r => r.enabled));
  }

  async update(ratios: IIntensityRatioUpdate[]): Promise<IIntensityRatio[]> {
    return this.http.patch(`intensity-ratio-setting`, { ratios })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}
